import { FC } from 'react'
import Avatar, { AvatarProps } from 'antd/es/avatar'
import { useAppSelector } from '../../store/hooks'
import { VenueTag as VenueTagModel } from '../../models/VenueTag'
import { Flex, Space, Typography } from 'antd'
import { selectVenueTagById } from '../../store/VenueTagReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Localizable } from '../localizable/Localizable'

const { Text } = Typography

type Props = SBModelComponent<VenueTagModel> & {
  size?: AvatarProps['size']
}

const VenueTagAvatar: FC<Props> = ({ id, model, size = 30 }) => {
  const item = model ? model : useAppSelector(selectVenueTagById(id!))

  if (!item) {
    return <></>
  }
  return (
    <Space>
      <Avatar src={item.icon} size={size}></Avatar>
      <Flex gap={10}>
        <Localizable.Render
          item={item}
          render={(localizedItem, lang) => (
            <Text>
              {lang.flag} {localizedItem.name}
            </Text>
          )}
        />
      </Flex>
    </Space>
  )
}

type VenueTagAvatarType = { Avatar: typeof VenueTagAvatar }

export { VenueTagAvatar, type VenueTagAvatarType }
